// NOTE: This file was automatically generated by a script. Do not modify this file manually.
// To regenerate this file, please use `pnpm scripts:microbootstrap-generator contracts`
// The command will generate files in the 'frontend/artifacts' folder with the list of files using collections
import { PropsWithChildren } from 'react'

import {
  CollectionBootstrapConfig,
  CollectionsBootstrap as CoreCollectionsBootstrap,
} from 'modules/core/components/CollectionsBootstrap'

import companies from 'modules/core/store/collections/companies'
import contractVersionsPayrollPolicies from 'modules/contracts/store/collections/contractVersionsPayrollPolicies'
import features from 'modules/core/store/collections/features'
import legalEntities from 'modules/core/store/collections/legalEntities'
import payrollPolicies from 'modules/payroll_bundle/store/collections/policies'

const CollectionsBootstrap = ({ children }: PropsWithChildren) => {
  const collections: CollectionBootstrapConfig[] = [
    [companies, {}] /* Referenced by 8 cases in this module */,
    [contractVersionsPayrollPolicies, {}] /* Referenced by 81 cases in this module */,
    [features, {}] /* Referenced by 26 cases in this module */,
    [legalEntities, {}] /* Referenced by 84 cases in this module */,
    [payrollPolicies, {}] /* Referenced by 91 cases in this module */,
  ] /* Generated file 👉 artifacts/contracts-module-employees.tsx-collection-dependencies-report-v2.json */

  return <CoreCollectionsBootstrap collections={collections}>{children}</CoreCollectionsBootstrap>
}

export default CollectionsBootstrap
